export default "__VITE_ASSET__uzw9H83L__"